// extracted by mini-css-extract-plugin
export default {"button":"rpyQi","link":"nYRfB","spinner":"H4RDG"};